import React from 'react';
import PropTypes from 'prop-types';
import {
    withStyles,
    Grid,
    Typography,
    Button,
} from '@material-ui/core';
import Translator from '%app/js/common/services/translator';
import Link from '%app/js/common/components/material/Link';

const style = theme => ({
    image: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(5),
        width: 160,
    },
    buttonGroup: {
        marginTop: theme.spacing(5),
        textAlign: 'center',
    },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
});


const resolveButton = ({
    buttonText,
    buttonAction,
    asRouteLink,
    classes: { button: className },
    children,
    createButtonId,
}) => {
    if (children !== null) {
        return React.cloneElement(<div>{children}</div>, { className });
    }

    if (asRouteLink) {
        return (
            <Link to={buttonAction}>
                <Button variant="contained" className={className} id={createButtonId}>
                    {Translator.trans(buttonText)}
                </Button>
            </Link>
        );
    }

    if (buttonText !== null && buttonAction !== null) {
        if (typeof buttonAction === 'function') {
            return (
                <Button variant="contained" className={className} onClick={buttonAction} id={createButtonId}>
                    {Translator.trans(buttonText)}
                </Button>
            );
        }
        return (
            <Button variant="contained" component="a" className={className} href={buttonAction} id={createButtonId}>
                {Translator.trans(buttonText)}
            </Button>
        );
    }

    return null;
};

function EmptyState({
    classes,
    image,
    headline,
    subheading,
    secondaryButtonText,
    secondaryButtonAction,
    secondaryButtonProps,
    disclaimer,
    ...rest
}) {
    return (
        <Grid container justify="center" alignItems="center" direction="column">
            <img className={classes.image} src={image} />
            <Typography variant="h5">
                {Translator.trans(headline)}
            </Typography>
            <Typography variant="subtitle1" align="center">
                {Translator.trans(subheading)}
            </Typography>
            {disclaimer}
            <div className={classes.buttonGroup}>
                {(secondaryButtonAction || secondaryButtonProps) && secondaryButtonText && (
                    <Button
                        variant="contained"
                        color="default"
                        className={classes.button}
                        onClick={secondaryButtonAction}
                        {...(secondaryButtonProps || {})}
                    >
                        {Translator.trans(secondaryButtonText)}
                    </Button>
                )}
                {resolveButton({ ...rest, classes })}
            </div>
        </Grid>
    );
}

EmptyState.propTypes = {
    classes: PropTypes.shape({
        image: PropTypes.string,
        buttonGroup: PropTypes.string,
        button: PropTypes.string,
    }).isRequired,
    image: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    subheading: PropTypes.string.isRequired,
    buttonText: PropTypes.string,
    secondaryButtonText: PropTypes.string,
    asRouteLink: PropTypes.bool,
    buttonAction: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
    ]),
    secondaryButtonAction: PropTypes.func,
    children: PropTypes.any,
    createButtonId: PropTypes.string,
    secondaryButtonProps: PropTypes.objectOf(PropTypes.any),
    disclaimer: PropTypes.node,
};

EmptyState.defaultProps = {
    buttonText: null,
    secondaryButtonText: null,
    buttonAction: null,
    secondaryButtonAction: null,
    asRouteLink: false,
    children: null,
    createButtonId: 'create-entry-button',
    secondaryButtonProps: null,
    disclaimer: null,
};

export default React.memo(withStyles(style)(EmptyState));
